/**
 * Stable per-tab builder lease holder id.
 *
 * Session-scoped on purpose: a reload in the same tab keeps the lease, a new tab/device gets its
 * own id and must "resume here?" to take over the draft.
 */
export function builderHolderId(): string {
  const key = "taskjinn.builder.holder";
  if (typeof sessionStorage === "undefined") return "server";
  const existing = sessionStorage.getItem(key);
  if (existing) return existing;
  const id =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `holder-${Math.random().toString(36).slice(2)}`;
  sessionStorage.setItem(key, id);
  return id;
}
